import { useCallback } from 'react'
import { GlobalEvents, StoreSafeObject } from '@highlight/ipc'
import WindowIpcRenderer from '@renderer/ipc/WindowIpc.renderer'
import { useSetSidepanelState } from '@renderer/overlay/atoms'
import { useSidepanelLocked } from '../atoms'

export function useOpenSettingsAndEmit() {
  const setSidepanelState = useSetSidepanelState()
  const locked = useSidepanelLocked()

  const openSettingsAndEmit = useCallback(
    async (event: string, payload?: StoreSafeObject) => {
      if (!locked) {
        setSidepanelState('hidden')
      }
      await WindowIpcRenderer.openSettingsWindow()

      // Wait for settings window to mount and register event listeners.
      // Uses event-based ready signal with timeout fallback.
      await new Promise<void>((resolve) => {
        let resolved = false
        const handler = () => {
          if (resolved) return
          resolved = true
          GlobalEvents.off('settings-window-ready', handler)
          resolve()
        }
        GlobalEvents.on('settings-window-ready', handler)

        // Fallback if window is already open (won't re-emit ready event)
        setTimeout(() => {
          if (resolved) return
          resolved = true
          GlobalEvents.off('settings-window-ready', handler)
          resolve()
        }, 500)
      })

      GlobalEvents.emit(event, payload)
    },
    [setSidepanelState, locked],
  )

  return openSettingsAndEmit
}
